/**
 * Implements the drag source contract.
 */

export const fieldSource = {
    beginDrag(props) {
        const { index: originalIndex } = props.findField(props.id);
        return {
            id: props.id,
            originalIndex,
        };
    },

    endDrag(props, monitor) {
        const { id: droppedId, originalIndex } = monitor.getItem();
        const didDrop = monitor.didDrop();

        if (!didDrop) {
            props.moveField(droppedId, originalIndex);
        }
    }
};

export const fieldTarget = {
    canDrop() {
        return true;
    },

    hover(props, monitor, component) {
        if (!component) {
            return null;
        }

        // Time to actually perform the action
        const { id: draggedId } = monitor.getItem();
        const { id: overId } = props;

        if (draggedId === overId) {
            return;
        }

        const { index: overIndex } = props.findField(overId);
        props.moveField(draggedId, overIndex);
      },
};

export const formTarget = {
    drop() {}
};

/**
 * Specifies the props to inject into your component.
 */

export const collectSource = (connect, monitor) => {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging()
    };
};

export const collectTarget = (connect, monitor) => {
    return {
        connectDropTarget: connect.dropTarget()
    };
};
